export default {
  "config": {
    "trial": "tones-5",
    "id": "ess-mitt-rwp",
    "type": "line",
    "title": "Epworth Sleepiness Scale (ESS) Scores Among Participants Who Entered the RW Phase (mITT Population)<sup>14</sup>",
    "xAxis": {
      "groups": [
        "1",
        "2",
        "3"
      ],
      "padding": 0.1,
      "label": {},
      "overrides": {
        "1": "BL<sup>b</sup>",
        "2": "Beginning of RW phase<sup>c</sup>",
        "3": "End of RW phase<sup>d</sup>"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": 0,
      "high": 25,
      "inc": 5,
      "label": {
        "text": [
          "ESS score, <no-break>mean ± SD</no-break><sup>a</sup>"
        ]
      }
    },
    "legend": [
      {
        "entry": "groupa",
        "label": "Group A baseline <no-break>(n = 225)</no-break>",
        "color": "#3a0071",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Group A"
      },
      {
        "entry": "groupb",
        "label": "Group B baseline <no-break>(n = 55)</no-break>",
        "color": "#b6d6d3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Group B"
      },
      {
        "entry": "pbo",
        "label": "Placebo <no-break>(n = 141)</no-break>",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo"
      },
      {
        "entry": "combined",
        "label": "Solriamfetol* <no-break>(n = 139)</no-break>",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol (combined)"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "*Solriamfetol doses include <no-break>37.5 mg,</no-break> <no-break>75 mg,</no-break> <no-break>150 mg,</no-break> and <no-break>300 mg.</no-break>",
      "<no-break>LS mean difference (95% CI): –3.7</no-break> <no-break>(–4.80, –2.65);</no-break> <no-break><em>P</em> < 0.0001.</no-break>",
      "<sup>a</sup>Normal range: <no-break>0 to 10.</no-break>",
      "<sup>b</sup>Values are for the mITT population at baseline of parent study in participants from group A <no-break>(n = 225)</no-break> and at baseline of current study in those from group B <no-break>(n = 55);</no-break> the RW phase included participants from both groups.",
      "<sup>c</sup>After <no-break>≥6 months</no-break> of treatment.",
      "<sup>d</sup>Two weeks from beginning to end of <no-break>RW phase.</no-break>"
    ],
    "useFootnoteTooltip": true,
    "trendLines": [
      {
        "y": 10,
        "color": "#000",
        "label": {
          "text": "Normal range",
          "textColor": "#000"
        },
        "lineType": "dashed"
      }
    ],
    "tooltipHeaders": [
      "Group",
      "Score"
    ],
    "nValueTable": {
      "type": "show-all-series",
      "sourceField": "y"
    },
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "groupa",
            "label": "Group A baseline <no-break>(n = 225)</no-break>",
            "color": "#3a0071",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Group A"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "groupb",
            "label": "Group B baseline <no-break>(n = 55)</no-break>",
            "color": "#b6d6d3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Group B"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo",
            "label": "Placebo <no-break>(n = 141)</no-break>",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "combined",
            "label": "Solriamfetol* <no-break>(n = 139)</no-break>",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol (combined)"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "name": "groupa",
      "color": "#3a0071",
      "sets": [
        {
          "name": "groupa",
          "color": "#3a0071",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Group A baseline, mean",
          "tooltipLabel": "Group A",
          "points": [
            {
              "x": 1,
              "y": 15.9,
              "extreme": {
                "upper": 3.42,
                "lower": 3.42
              },
              "label": {
                "text": 15.9,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "groupb",
      "color": "#b6d6d3",
      "sets": [
        {
          "name": "groupb",
          "color": "#b6d6d3",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Group B baseline, mean",
          "tooltipLabel": "Group B",
          "points": [
            {
              "x": 1,
              "y": 16.2,
              "extreme": {
                "upper": 4,
                "lower": 4
              },
              "label": {
                "text": 16.2,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "pbo",
      "color": "#868686",
      "sets": [
        {
          "name": "pbo",
          "color": "#868686",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Placebo, mean",
          "tooltipLabel": "Placebo",
          "points": [
            {
              "x": 1,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 7.8,
              "extreme": {
                "upper": 4.98,
                "lower": 4.98
              },
              "label": {
                "text": 7.8,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 12.6,
              "extreme": {
                "upper": 5.65,
                "lower": 5.65
              },
              "label": {
                "text": 12.6,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    },
    {
      "name": "combined",
      "color": "#006e8a",
      "sets": [
        {
          "name": "combined",
          "color": "#006e8a",
          "line": "solid",
          "shape": "dot",
          "nValueLabel": "Solriamfetol, mean",
          "tooltipLabel": "Solriamfetol (combined)",
          "points": [
            {
              "x": 1,
              "y": null,
              "extreme": {
                "upper": null,
                "lower": null
              },
              "label": {
                "text": null,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 2,
              "y": 7.3,
              "extreme": {
                "upper": 5.31,
                "lower": 5.31
              },
              "label": {
                "text": 7.3,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            },
            {
              "x": 3,
              "y": 8.5,
              "extreme": {
                "upper": 5.75,
                "lower": 5.75
              },
              "label": {
                "text": 8.5,
                "sup": null,
                "override": ""
              },
              "nvalue": null
            }
          ]
        }
      ]
    }
  ]
};